<template>
  <div>
    <FlashMessage v-if="this.messages.text != ''" :message="this.messages" />
    <div
      class="fixed inset-0 bg-black/50 flex items-center justify-center p-4 z-50"
      style="z-index: 5000"
    >
      <div
        class="w-full max-w-2xl bg-white rounded-2xl shadow-2xl max-h-[90vh] overflow-y-auto"
        style="scrollbar-width: thin"
      >
        <!-- Header -->
        <div
          class="sticky top-0 z-10 bg-white px-6 py-4 border-b border-gray-100"
        >
          <div class="flex items-center justify-between">
            <div class="flex items-center gap-2.5">
              <div class="p-1.5 bg-blue-600 rounded-lg">
                <svg
                  class="w-4 h-4 text-white"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M8 7v8a2 2 0 002 2h6M8 7V5a2 2 0 012-2h4.586a1 1 0 01.707.293l4.414 4.414a1 1 0 01.293.707V15a2 2 0 01-2 2h-2M8 7H6a2 2 0 00-2 2v10a2 2 0 002 2h8a2 2 0 002-2v-2"
                  />
                </svg>
              </div>

              <div>
                <h3 class="text-sm font-semibold text-gray-900">
                  Duplicate Course
                </h3>
                <p class="text-[10px] text-gray-500">
                  Create a copy of existing course
                </p>
              </div>
            </div>

            <button
              @click="$emit('cancelClick')"
              class="p-1.5 rounded-lg hover:bg-gray-100"
            >
              <svg
                class="w-4 h-4 text-gray-400"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </button>
          </div>
        </div>

        <form
          ref="changeduplicateRef"
          @submit.prevent="duplicateCourse"
          class="pt-5 pb-10 px-8 space-y-4"
        >
          <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
            <!-- Title -->
            <div class="space-y-1.5">
              <label class="text-xs font-medium text-gray-700">
                Title <span class="text-red-500">*</span>
              </label>

              <input
                id="title"
                type="text"
                required
                class="w-full px-3 py-2 bg-gray-50 border border-gray-200 rounded-lg text-xs outline-none focus:border-blue-500 focus:ring-1 focus:ring-blue-500"
                placeholder="Enter course title"
              />
            </div>

            <!-- Batch -->
            <div class="space-y-1.5">
              <label class="text-xs font-medium text-gray-700">
                Batch <span class="text-red-500">*</span>
              </label>

              <select
                v-model="batch_id"
                @change="onBatchChange"
                required
                class="w-full px-3 py-2 bg-gray-50 border border-gray-200 rounded-lg text-xs outline-none focus:border-blue-500 focus:ring-1 focus:ring-blue-500"
              >
                <option value="" disabled>Select Batch</option>

                <option
                  v-for="batch in batchs"
                  :key="batch.id"
                  :value="batch.id"
                >
                  {{ batch.year }}
                </option>
              </select>
            </div>

            <!-- Program -->
            <div class="space-y-1.5">
              <label class="text-xs font-medium text-gray-700">
                Program Name <span class="text-red-500">*</span>
              </label>

              <select
                v-model="program_id"
                @change="onProgramChange"
                required
                :disabled="!batch_id"
                class="w-full px-3 py-2 bg-gray-50 border border-gray-200 rounded-lg text-xs outline-none focus:border-blue-500 focus:ring-1 focus:ring-blue-500"
              >
                <option value="" disabled>Select Program</option>

                <option
                  v-for="program in programs"
                  :key="program.id"
                  :value="program.id"
                >
                  {{ program.name }}
                </option>
              </select>
            </div>
            <div class="flex flex-col gap-3 hidden">
              <label for="department" class="text-sm flex gap-2"
                >Department <span class="text-red-400">*</span>
              </label>
              <select
                v-model="department_id"
                required
                class="bg-gray-100 rounded-lg text-sm w-full p-3"
                disabled
              >
                <option value="" disabled>Auto-selected Department</option>
                <option
                  v-for="department in departments"
                  :key="department.id"
                  :value="department.id"
                >
                  {{ department.name }}
                </option>
              </select>
            </div>
            <!-- Semester -->
            <div class="space-y-1.5">
              <label class="text-xs font-medium text-gray-700">
                Semester <span class="text-red-500">*</span>
              </label>

              <select
                v-model="semester_id"
                @change="onSemesterChange"
                :class="
                  !semetser_list || semetser_list.length === 0 || !program_id
                    ? 'bg-gray-200'
                    : 'bg-[#F9FAFC]'
                "
                required
                :disabled="!program_id"
                class="w-full px-3 py-2 border border-gray-200 rounded-lg text-xs outline-none focus:border-blue-500 focus:ring-1 focus:ring-blue-500"
              >
                <option value="" disabled>Select Semester</option>

                <option
                  v-for="semester in semetser_list || []"
                  :key="semester.id"
                  :value="semester.id"
                >
                  {{ semester.semester }}
                </option>
              </select>
            </div>
            <!-- Faculty -->
            <div class="col-span-1 md:col-span-2 space-y-1.5">
              <label
                class="text-xs font-medium text-gray-700 flex items-center"
              >
                Select Faculty
                <span class="text-red-500 ml-1">*</span>

                <span class="text-[10px] text-gray-400 ml-auto">
                  {{ instructor_id.length }} selected
                </span>
              </label>

              <div
                class="border border-gray-200 rounded-lg p-2 max-h-[100px] overflow-y-auto"
                :class="
                  instructor_lists.length === 0 ? 'bg-gray-200' : 'bg-white'
                "
              >
                <div
                  v-if="instructor_lists.length === 0"
                  class="text-xs text-gray-400 text-center py-2"
                >
                  No faculty available
                </div>

                <label
                  v-for="instructor in instructor_lists"
                  :key="instructor.id"
                  class="flex items-center gap-2 p-1.5 rounded cursor-pointer"
                >
                  <input
                    type="checkbox"
                    :value="instructor.id"
                    v-model="instructor_id"
                    class="w-3.5 h-3.5 text-blue-600 rounded border-gray-300"
                  />

                  <span class="text-xs text-gray-700">
                    {{ instructor.user.email }}
                  </span>
                </label>
              </div>
            </div>
            <!-- Section -->
            <div class="space-y-1.5">
              <label class="text-xs font-medium text-gray-700">
                Section <span class="text-red-500">*</span>
              </label>

              <select
                v-model="section_id"
                required
                :disabled="!semester_id"
                class="w-full px-3 py-2 bg-gray-50 border border-gray-200 rounded-lg text-xs outline-none focus:border-blue-500 focus:ring-1 focus:ring-blue-500"
              >
                <option value="" disabled>Select Section</option>

                <option
                  v-for="section in sections || []"
                  :key="section.id"
                  :value="section.id"
                >
                  {{ section.name }}
                </option>
              </select>
            </div>

            <!-- Course Code -->
            <div class="space-y-1.5">
              <label class="text-xs font-medium text-gray-700">
                Course Code <span class="text-red-500">*</span>
              </label>

              <input
                type="text"
                id="course_code"
                maxlength="30"
                required
                class="w-full px-3 py-2 bg-gray-50 border border-gray-200 rounded-lg text-xs outline-none focus:border-blue-500 focus:ring-1 focus:ring-blue-500"
                placeholder="Enter course code"
              />
            </div>

            <!-- Course Type -->
            <div class="space-y-1.5">
              <label class="text-xs font-medium text-gray-700">
                Course Type
              </label>

              <select
                id="course_type"
                class="w-full px-3 py-2 bg-gray-50 border border-gray-200 rounded-lg text-xs outline-none focus:border-blue-500 focus:ring-1 focus:ring-blue-500"
              >
                <option value="" selected disabled>Select Course Type</option>

                <option
                  v-for="type in courseTypeList"
                  :key="type.id"
                  :value="type.id"
                >
                  {{ type.title }}
                </option>
              </select>
            </div>

            <!-- Thumbnail -->
            <div class="col-span-1 md:col-span-2">
              <div class="flex flex-col space-y-1.5">
                <label
                  for="thumbnail"
                  class="text-xs font-medium text-gray-700"
                >
                  Thumbnail <span class="text-red-500">*</span>
                </label>

                <input
                  id="thumbnail"
                  type="file"
                  required
                  class="border border-gray-300 rounded-lg text-xs px-3 py-2 outline-none focus:border-blue-500 focus:ring-1 focus:ring-blue-500 file:mr-3 file:py-1 file:px-3 file:rounded-lg file:border-0 file:bg-blue-50 file:text-blue-600 file:text-xs hover:file:bg-blue-100"
                />
              </div>
            </div>
          </div>

          <!-- Checkboxes -->
          <div class="grid grid-cols-2 md:grid-cols-4 gap-3 pt-1">
            <label
              class="flex items-center gap-2 p-2 bg-gray-50 rounded-lg border"
            >
              <input type="checkbox" id="Published" class="w-3.5 h-3.5" />
              <span class="text-xs font-medium">Published</span>
            </label>

            <label
              class="flex items-center gap-2 p-2 bg-gray-50 rounded-lg border"
            >
              <input type="checkbox" id="Assignment" class="w-3.5 h-3.5" />
              <span class="text-xs font-medium">Assignment</span>
            </label>

            <label
              class="flex items-center gap-2 p-2 bg-gray-50 rounded-lg border"
            >
              <input type="checkbox" id="Assessment" class="w-3.5 h-3.5" />
              <span class="text-xs font-medium">Assessment</span>
            </label>

            <label
              class="flex items-center gap-2 p-2 bg-gray-50 rounded-lg border"
            >
              <input type="checkbox" id="Project" class="w-3.5 h-3.5" />
              <span class="text-xs font-medium">Project</span>
            </label>
          </div>

          <!-- Buttons -->

          <div
            class="flex items-center justify-end gap-2 pt-3 border-t border-gray-200 mt-1"
          >
            <button
              type="button"
              @click="$emit('cancelClick')"
              class="px-4 py-1.5 text-xs font-medium text-gray-600 bg-gray-100 rounded-lg hover:bg-gray-200"
            >
              Cancel
            </button>
            <button
              type="submit"
              :disabled="disable_submit == true"
              class="px-4 py-1.5 text-xs font-semibold text-white rounded-lg flex items-center gap-2"
              :class="
                disable_submit
                  ? 'bg-gray-400 cursor-not-allowed'
                  : 'bg-blue-600 hover:bg-blue-700'
              "
            >
              <svg
                v-if="!disable_submit"
                class="w-3.5 h-3.5"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M5 13l4 4L19 7"
                />
              </svg>
              {{ disable_submit ? "Duplicating..." : "Duplicate" }}
            </button>
            <img
              v-if="disable_submit"
              src="@/assets/loading.gif"
              alt="loading"
              class="w-5 h-5 object-contain"
            />
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { mapGetters } from "vuex";
import FlashMessage from "@/components/FlashMessage.vue";

export default {
  props: ["id"],
  emits: ["cancelClick", "confirmClick"],
  data() {
    return {
      batchs: [],
      programs: [],
      departments: [],
      courseTypeList: [],
      isDepartment: false,
      isPrograms: false,
      instructor_lists: [],
      semetser_list: [],
      sections: [],
      program_id: "",
      department_id: "",
      batch_id: "",
      semester_id: "",
      section_id: "",
      instructor_id: [],
      disable_submit: false,
      messages: {
        text: "",
        type: "null",
      },
      errorMessage: "",
      errorgreenMessage: "",
    };
  },
  components: {
    FlashMessage,
  },
  computed: {
    ...mapGetters(["userInfo"]),
  },
  async created() {
    this.getBatch();
    // this.getPrograms();
    this.sectionsGet();
    this.getCourseTypeList();
  },
  methods: {
    getCourseTypeList() {
      axios
        .get(
          `${process.env.VUE_APP_API}/course_type/?Key=${this.userInfo.token_key}`,
        )
        .then((res) => {
          this.courseTypeList = res.data.data;
        });
    },
    getBatch() {
      axios
        .get(
          `${process.env.VUE_APP_API}/batch-list/?Key=${this.userInfo.token_key}`,
        )
        .then((res) => {
          this.batchs = res.data.data;
        });
    },
    onBatchChange() {
      this.clearDependentFields();

      if (this.batch_id) {
        this.getPrograms();
      }
    },
    clearDependentFields() {
      this.programs = [];
      this.departments = [];
      this.semetser_list = [];
      this.instructor_lists = [];
      this.program_id = "";
      this.department_id = "";
      this.semester_id = "";
      this.section_id = "";
      this.instructor_id = [];
    },
    getPrograms() {
      axios
        .get(
          `${process.env.VUE_APP_API}/program-list/?batch__id=${this.batch_id}&Key=${this.userInfo.token_key}`,
        )
        .then((res) => {
          this.programs = res.data.data;
        })
        .catch(() => {
          this.programs = [];
        });
    },
    onProgramChange() {
      this.departments = [];
      this.semetser_list = [];
      this.instructor_lists = [];
      this.department_id = "";
      this.semester_id = "";
      this.section_id = "";
      this.instructor_id = [];

      if (this.program_id) {
        this.getDepartmentsAndSemesters();
      }
    },
    getDepartmentsAndSemesters() {
      axios
        .get(
          `${process.env.VUE_APP_API}/department-list/?Key=${this.userInfo.token_key}&program__id=${this.program_id}`,
        )
        .then((res) => {
          this.departments = res.data.data.map((item) => ({
            id: item.id,
            name: item.name,
          }));

          if (this.departments.length > 0) {
            this.department_id = this.departments[0].id;
            this.getSemestersAndInstructors();
          }
        })
        .catch(() => {
          this.departments = [];
        });
    },
    clearSemesterAndSection() {
      this.semetser_list = [];
      this.semester_id = "";
      this.section_id = "";
    },

    clearSection() {
      this.section_id = "";
    },
    getSemestersAndInstructors() {
      if (!this.department_id || !this.batch_id) return;

      axios
        .get(
          `${process.env.VUE_APP_API}/semetser-get/?Key=${this.userInfo.token_key}&department__id=${this.department_id}&batch__id=${this.batch_id}`,
        )
        .then((res) => {
          this.semetser_list = res.data.data;
        })
        .catch(() => {
          this.semetser_list = [];
        });

      axios
        .get(
          `${process.env.VUE_APP_API}/instructor_all/?Key=${this.userInfo.token_key}`,
        )
        .then((res) => {
          this.instructor_lists = res.data.products || [];
        })
        .catch(() => {
          this.instructor_lists = [];
        });
    },

    onSemesterChange() {
      this.clearSection();
    },

    getProgramsFilter(index, program_id) {
      // let program_name = document.getElementById("program_name").value;
      console.log(index);
      axios
        .get(
          `${process.env.VUE_APP_API}/department-list/?Key=${this.userInfo.token_key}&program__id=${program_id}`,
        )
        .then((res) => {
          // this.departments = res.data.data;
          // this.departments = res.data.data;
          this.departments = res.data.data.map((item) => ({
            id: item.id,
            name: item.name,
          }));
          if (this.departments.length > 0) {
            this.department_id = this.departments[0].id;
            this.getInstructorListByFilter(index, this.department_id);
            this.getSemesterFilter(index, this.department_id);
          }
          console.log("department_id:", this.department_id);
        });
    },
    getInstructorListByFilter(index, department_id) {
      // let department_name = document.getElementById("department").value;
      console.log(index);
      axios
        .get(
          `${process.env.VUE_APP_API}/instructor_all/?Key=${this.userInfo.token_key}`,
        )
        .then((res) => {
          console.log(res);
          // this.instructor_lists = res.data.products;
          this.instructor_lists = res.data.products;
        });
    },
    getSemesterFilter(index, department_id) {
      let batch_year = 1;
      // let department_name = document.getElementById("department").value;
      console.log(index);
      axios
        .get(
          `${process.env.VUE_APP_API}/semetser-get/?Key=${this.userInfo.token_key}&department__id=${department_id}&batch__id=${batch_year}`,
        )
        .then((res) => {
          // this.semetser_list = res.data.data;
          this.semetser_list = res.data.data;
        });
    },
    sectionsGet() {
      axios
        .get(
          `${process.env.VUE_APP_API}/section-list/?Key=${this.userInfo.token_key}`,
        )
        .then((res) => {
          this.sections = res.data.data;
        })
        .catch(() => {
          this.sections = [];
        });
    },
    async validateCourseCode() {
      this.course_code = document.getElementById("course_code").value;
      axios
        .get(
          `${process.env.VUE_APP_API}/course/code/checker/?course_code=${this.course_code}&Key=${this.userInfo.token_key}`,
        )
        .then((response) => {
          if (response.data.status == 200) {
            // this.errorgreenMessage=response.data.message;
            // this.errorgreenMessage =
            //   "course code vaild";
            this.errorMessage = "";
          } else if (response.data.status == 400) {
            this.errorMessage = response.data.message;
          }
        });
    },

    duplicateCourse(e) {
      e.preventDefault();

      if (this.disable_submit) return;

      this.disable_submit = true;
      let HeaderVal = new FormData();
      if (e.target.elements.thumbnail.files.length > 0) {
        var thumbnailVal = e.target.elements.thumbnail.files[0];
        HeaderVal.append("thumbnail", thumbnailVal);
      }
      HeaderVal.append("title", e.target.elements.title.value);
      HeaderVal.append("course_code", e.target.elements.course_code.value);
      HeaderVal.append("batch", this.batch_id);
      HeaderVal.append("program", this.program_id);
      HeaderVal.append("department", this.department_id);
      HeaderVal.append("semester", this.semester_id);
      HeaderVal.append("class_section", this.section_id);
      // this.instructor_id.forEach((id) => {
      //   HeaderVal.append("instructor", Number(id));
      // });
      HeaderVal.append("instructor", JSON.stringify(this.instructor_id));
      HeaderVal.append("is_published", e.target.elements.Published.checked);
      HeaderVal.append("assignment", e.target.elements.Assignment.checked);
      HeaderVal.append("assessment", e.target.elements.Assessment.checked);
      HeaderVal.append("project", e.target.elements.Project.checked);
      HeaderVal.append("original_course_id", Number(this.id));
      HeaderVal.append("course_type", e.target.elements.course_type.value);

      axios
        .post(
          `${process.env.VUE_APP_API}/course/clone/?Key=${this.userInfo.token_key}`,
          HeaderVal,
        )
        .then((response) => {
          if (response.data.status === 200) {
            this.messages = {
              text: response.data.message,
              type: "success",
            };

            setTimeout(() => {
              this.messages = { text: "", type: null };
              this.$refs.changeduplicateRef.reset();
              this.program_id = "";
              this.department_id = "";
              this.semester_id = "";
              this.section_id = "";
              this.instructor_id = [];
              this.errorMessage = "";
              this.errorgreenMessage = "";
              this.$emit("cancelClick");
              this.disable_submit = false;
            }, 1500);
          } else {
            this.messages = {
              text: response.data.message,
              type: "error",
            };
            setTimeout(() => {
              this.messages = { text: "", type: null };
              this.disable_submit = false;
            }, 1500);
          }
        })
        .catch(() => {
          this.messages = {
            text: "Course duplication failed",
            type: "error",
          };
          this.disable_submit = false;
          setTimeout(() => {
            this.messages = { text: "", type: null };
          }, 1500);
        });
    },
  },
};
</script>

<style scoped></style>
